import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import { Plan, SelectOption } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerFeaturesTasksDropdown',
  props: {
    plan: null,
    isSelected: { type: Boolean },
    selectOptions: null,
    selectedCustomerFeatureTasksAmount: null
  },
  emits: ["update-selected-option-value", "update-customer-features-tasks-quantity"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update-selected-option-value', selectedCustomerFeatureTasksAmount: number): void;
	(e: 'update-customer-features-tasks-quantity', customerFeaturesTasksQuantity: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	plan: Plan;
	isSelected: boolean;
	selectOptions: SelectOption[];
	selectedCustomerFeatureTasksAmount: number;
}



const isSelected = computed(() => props.isSelected);
const onChange = (customerFeaturesTasksQuantity: number) => {
	emit('update-selected-option-value', customerFeaturesTasksQuantity);
	if (isSelected.value) {
		emit('update-customer-features-tasks-quantity', customerFeaturesTasksQuantity);
	}
};
watch(isSelected, (newValue) => {
	if (newValue) {
		emit('update-customer-features-tasks-quantity', props.selectedCustomerFeatureTasksAmount);
	}
});

return { __sfc: true,emit, props, isSelected, onChange }
}

})